
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 46 46","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M0 0h22.745v26.924H0z"}})]),_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M23.5 1C11.073 1 1 11.074 1 23.498 1 35.926 11.073 46 23.5 46S46 35.926 46 23.498C46 11.074 35.927 1 23.5 1z","fill":"#4FA2B7"}}),_c('g',{attrs:{"transform":"translate(12 10)"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('path',{attrs:{"d":"M13.061 14.377l9.146-11.131C23.226 2.006 22.755 1 21.154 1H1.903C.303 1-.19 2.022.805 3.283l8.879 11.263L.538 25.678c-1.019 1.24-.548 2.246 1.052 2.246h19.252c1.6 0 2.092-1.022 1.098-2.283l-8.879-11.264z","fill":"#FFF","mask":"url(#b)"}})])])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/objectIcons/central office.svg